import React from 'react'

interface SubmitButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean
  children: React.ReactNode
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ isLoading = false, children, ...props }) => {
  return (
    <button
      aria-label="submitbutton"
      type="submit"
      className={`w-full bg-primary text-white uppercase py-2 rounded flex items-center justify-center ${
        isLoading ? 'opacity-70 cursor-not-allowed' : ''
      }`}
      disabled={isLoading}
      {...props}
    >
      {isLoading ? (
        <div
          className="w-6 h-6 rounded-full animate-spin border-4 border-solid border-white border-t-transparent"
          role="status"
        ></div>
      ) : (
        children
      )}
    </button>
  )
}

export default SubmitButton
